import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import LinearProgress from "@material-ui/core/LinearProgress";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import InstitutionDropDown from "../../../components/dropDown/institution";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import Divider from "@material-ui/core/Divider";


const MaintenanceDomainsView = (props) => {

    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <div>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={8}>
                            <TitlePage title="Mantenimiento \ Dominios"/>
                        </Grid>
                        <Grid item xs={4} style={{textAlign: 'right'}}>
                            <Button label="Buscar" onClick={props.getDataDomains}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{textAlign: 'right'}}>
                                <Button label="Contraer / Expandir Grupos" className="p-button-secondary"
                                        onClick={props.expandReduceAll}
                                        style={{visibility: 'hidden'}}/> &nbsp;
                                <Button type="button" iconPos="left" label="Agregar"
                                        className="p-button-secondary"
                                        onClick={props.addDomain}/>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="content-section implementation">
                                <DataTable
                                    value={props.dataDomains}
                                    expandedRows={props.expandedRows}
                                    onRowToggle={props.handleToggle}
                                    rowExpansionTemplate={props.rowExpansionTemplate}
                                    resizableColumns={true}
                                    columnResizeMode={"fit"}>
                                    <Column expander={true} style={{width: '3em'}}/>
                                    <Column field="nomCorto" header="Institución" style={{textAlign: 'left'}} sortable={true}/>
                                </DataTable>
                            </div>
                        </Grid>
                        <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                                onHide={props.onHideDialog} closable={false} style={{width: "30%"}}
                                contentStyle={{overflow:'visible'}}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12 p-lg-6">
                                    <SubtitleLabel header="Institución" isBold={true}/>
                                    {props.isInterno ?
                                        <InstitutionDropDown
                                            name="instObj"
                                            filter="nombreCorto"
                                            save={props.onChangeDropDown}
                                            value={props.domainData.instObj}
                                            loading={props.loading}/> :
                                        <SubtitleLabel header={props.domainData.nombreCorto}/>
                                    }
                                </div>
                                <div className="p-col-12 p-md-12 p-lg-6">
                                    <SubtitleLabel header="Dominio" isBold={true}/>
                                    <InputText name="domain"
                                               required={true}
                                               onChange={props.onChangeText}
                                               value={props.domainData.domain}/>
                                </div>
                            </div>
                        </Dialog>
                    </Grid>
                </Paper>
            </div>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(MaintenanceDomainsView);
